// #region Dependencias
import styled from 'styled-components'
import { colors } from 'components/Library/theme'
// #endregion

// #region Estilos
const StyledListItem = styled.li`
  align-items: center;
  border-radius: 0.5rem;
  flex-direction: ${({ flexDirection = 'row' }) => flexDirection};
  flex-basis: calc(${({ flexBasis }) => flexBasis}% - 1rem);
  width: 100%;

  ${({ contentEditable }) => contentEditable && `
    &:hover {
      box-shadow: 0px 0px 0px 2px ${colors.secondary};
    }

    &:focus-visible {
      box-shadow: 0px 0px 0px 2px ${colors.secondary};
      outline: none;
    }
  `}
`
// #endregion

/**
 * Componente que renderiza un <li />.
 *
 * @class
 * @example <ListItem>...</ListItem>
 * @param {Object} props - Propiedades del componente.
 * @param {string} [props.flexDirection="row"] - Atributo 'flex-direction' del componente.
 * @param {string} [props.flexBasis=null] - Atributo 'flex-basis' del componente.
 * @param {React.ReactNode} props.children - Contenido que será renderizado dentro del componente.
 */
const ListItem = ({ children, ...props }) => {
  return <StyledListItem {...props}>{children}</StyledListItem>
}

export default ListItem
